module.exports = __webpack_public_path__ + "img/everyBody_04.da3d1cf5.png";